module.exports = __webpack_public_path__ + "static/media/CC20-AP090-12.a5a0af65.png";